export const focus = () => ({
    '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 0.2rem rgba(38, 143, 255, 0.5)',
    },
});
